export enum CityAnalyticsEnum {
  VIEW_CITIES_INDEX_PAGE = '[PAC WEB] Índice de Cidades - Página visualizada',

  EXPAND_STATE_UF_CITIES_PAGE = '[PAC WEB] Índice Cidades - Expandiu estado (UF)',

  CLICK_CARD_ITEM_CITY_PAGE = '[PAC WEB] Índice de Cidades - Clicou na cidade',
  CLICK_SEE_MORE_BY_CITY_PAGE = '[PAC WEB] Índice de Cidades - Clicou em "Ver mais" por estado (UF)',
  CLICK_SEARCH_CITIES_FILTER = '[PAC WEB] Índice de Cidades - Clicou em "Buscar"',
}
